/* eslint-disable no-use-before-define */
import React from 'react';
import  ReactDropDownAutoComplete  from 'react-dropdown-autocomplete';
import './common.css';
import { getlanguagelist } from "../../helpers/changelanguage";
import $ from 'jquery';


export default function AutoComplete(prop) {
  const dataList = prop.dataList;

  const onchange = (vall) => {
       
    let matchedIndex = dataList.map(function (obj) { return obj.country_name; }).indexOf(vall);
    if(matchedIndex >= 0){
      $('#country_name').parent().find('i').removeClass('fa fa-blank').addClass('fa fa-times-circle');
        let newCountry = {
            country_name        : vall,
            country_code        : dataList[matchedIndex].country_code,
            country_id          : dataList[matchedIndex].id,
            country_dial_code   : dataList[matchedIndex].country_dial_code,
            country_flag_code   : dataList[matchedIndex].country_flag_code
        }
        prop.changeCountry(newCountry);
    }
  }
  
  const clearVal =()=>{
    $('#country_name').parent().find('i').removeClass('fa fa-times-circle').addClass('fa fa-blank');
    
    document.getElementById('country_name').value = ''
    let newCountry = {
      country_name : null,
      country_code : null
    }
    prop.changeCountry(newCountry);
  }
  let  languagelist    = getlanguagelist();

  return (
    <ReactDropDownAutoComplete
        getItemValue={item => `${item.country_name}`}
        className="form-control"
        id="country_name"
        name="country_name"
        placeholder={languagelist.country}
        data={dataList || []}
        renderItem={item => (
          <div 
            role="button"
            tabIndex="-1"
            onClick={(val) => onchangek(val)}
          >{item.country_name} - {item.country_code}</div>
        )}
        icon='blank'
        iconColor="#ec5555"
        iconClick={() => clearVal()}
        value={prop.defaultVal}
        onChange={(val) => onchange(val)}
        onEnter={() => { /* TODO */ }}
      />
  );
}

// From https://bitbucket.org/atlassian/atlaskit-mk-2/raw/4ad0e56649c3e6c973e226b7efaeb28cb240ccb0/packages/core/select/src/data/countries.js
const countries = [
  
];
